"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivePartnerFeatureIds = void 0;
const partner_data_client_1 = require("@evenfinancial/partner-data-client");
const getActivePartnerFeatureIds = (activePartnerFeatures) => activePartnerFeatures.reduce((acc, { feature, id }) => {
    var _a;
    const featureKey = (_a = Object.entries(partner_data_client_1.PartnerFeature).find(([, value]) => value === feature)) === null || _a === void 0 ? void 0 : _a[0];
    if (featureKey) {
        acc[featureKey] = id;
    }
    return acc;
}, {});
exports.getActivePartnerFeatureIds = getActivePartnerFeatureIds;
